var React = require('react');

var ReactDOM = require('react-dom');

var $ = require("jquery");
var smartScroll = require("../vendor/jquery.smartScroll");

var InsuranceClauseDialog = React.createClass({
  propTypes: {
     pid: React.PropTypes.string,
     pname: React.PropTypes.string
  },


  getInitialState(){
     return {
         left: this.props.left
     }
  },

  openDialog(){
    var dialog = this.getDialog();
    dialog.show();
  },

  getDialog(){
    var tpl = [
        '<div class="mod-dialog no-appoint-room-dialog" style="z-index: 3000; display:none;">',
            '<div class="hd">',
                '<h3>指定房型建议：</h3>',
                '<span class="close"></span>',
            '</div>',
            '<div class="bd" >',
                '<p>一、两位为情侣或夫妻关系，可视情况指定大床或者双床；若无需要可以不指定；</p>',
                '<p>二、两位为同性普通朋友出行，建议提前指定双床房；</p>',
                '<p>三、三位成年人一间房，建议提前指定三人间；</p>',
                '<p>四、两位成年人携带2位小孩，建议预定两间房；如果只要一间房，请提前和旅行顾问沟通询问细节</p>',
            '</div>',
        '</div>'
    ].join('');

    $("body").append(tpl).append('<div class="mod-overlay no-appoint-room-dialog-overlay" style="z-index: 2998; display: block;"></div>');

    return {
      show:function(){
        var dialog = $(".no-appoint-room-dialog")
        , winWidth = $(window).width()
        , winHeight = $(window).height()
        , width = dialog.width()
        , height = dialog.height()
        ;

        dialog.css({
          top: winHeight / 2 - height / 2,
          left: winWidth / 2 - width / 2
        }).show();
   
        var scroll_top = $(window).scrollTop();
        
        $.smartScroll(dialog);
        $("html").addClass("page-scroll-fixed");
        dialog.find(".close").on("click", function(){
          dialog.hide().remove();
          $('.no-appoint-room-dialog-overlay').remove();
          $("html").removeClass("page-scroll-fixed");
          $(window).scrollTop(scroll_top);
        });

      }
    };

  },

  render(){
    return  <span className="js-noappoint-tip" onClick={ this.openDialog }><i className="icon-super-detail-tip-6-b"></i>指定房型建议</span>;
    
  }
});

module.exports = InsuranceClauseDialog;



/** WEBPACK FOOTER **
 ** ./script/detail-m/NoAppinotDialog.jsx
 **/